import React from "react";

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';

import TextField from "@material-ui/core/TextField";
import {
  IconButton,
  FormControl,
  Card,
  Button,
  Select,
  OutlinedInput,
  Checkbox,
  FormControlLabel,
  Grid
} from "@material-ui/core";

import { KeyboardDatePicker, TimePicker } from "@material-ui/pickers";

import EditIcon from "@material-ui/icons/Edit";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import AddBoxIcon from "@material-ui/icons/AddBox";
import SaveIcon from '@material-ui/icons/Save';

import screeningStyles from "./screeningDetails.module.css";
import commonStyles from '../common/common.module.css';
import moment from "moment";
import Screening from "../../models/Screening";

import QueryBuilder from '@material-ui/icons/QueryBuilder';
import InputAdornment from '@material-ui/core/InputAdornment';
import Exemption from "../../models/Exemptions";
import { alarmList, alternativeScreeningOptions, exemptionsList, measureTypes, screenedOptions } from "../../utils/screening";

const styles = (theme: Theme) =>

  createStyles({
    red: {
      backgroundColor: 'red !important',
    },
    activeTab : {
      '&.MuiTab-textColorInherit.Mui-selected': {
        backgroundColor: 'var(--secondarygreen)',
      }
    },
    tabWrapper: {
      '& .MuiTabs-indicator': {
        display: 'none'
      }
    }
  });

interface ScreeningCardProps {
  classes: any;
  flight: string;
  piecesSplit: Array<Screening>;
  changePieces: (event: any) => void;
  selectFlight: (event: any) => void;
  changeDetails: (event: any, type: string) => void;
  selectDate: (date: Date, index: number, type: string) => void;
  submitScreening: (event: any, i: number) => void;
  handleDateChange: (date: Date, index: number) => void;
  editCard: (index: number) => void;
  deleteCard: (index: number) => void;
  handleSelectChange: (event: any, type: string) => void;
  addCard: () => void;
  measures: Array<string>;
  alarmResolutions: Array<string>;
  setUserManually: (event: any) => void;
  exemptions: Exemption;
  disableScreening: boolean;
  errorMessage?: string;
}

const TEXT_FIELD_PADDINGS: string = '6px 12px';
const SELECT_FONT_SIZE: string = '13px';

const screeningCard = (props: ScreeningCardProps) => {
  let flightExemptionOptions: Array<JSX.Element> = [];
  let alternativeOptions: Array<JSX.Element> = [];
  let screening: Array<JSX.Element> = [];
  let measureAppliedOptions: Array<JSX.Element> = [];
  let alarmResolutionOptions: Array<JSX.Element> = [];
  let exemptionsDomesticOptions: Array<JSX.Element> = [];
  let exemptionsIntOptions: Array<JSX.Element> = [];
  let chainOfCustodyOptions: Array<JSX.Element> = [];
  let otheroptions: Array<JSX.Element> = [];

  if(props.exemptions.exemptions) {
    flightExemptionOptions = props.exemptions.exemptions.map((exemptions :string, index: number) => (
      <option key={ index } value={ exemptions }>{ exemptions }</option>
    ));
  } else {
    flightExemptionOptions = exemptionsList.map((exemptions :string, index: number) => (
      <option key={ index } value={ exemptions }>{ exemptions }</option>
    ));
  }

  if(props.alarmResolutions && props.alarmResolutions.length > 0) {
    alarmResolutionOptions = props.alarmResolutions.map((alarm :string, index: number) => (
      <option key={ index } value={ alarm }>{ alarm }</option>
    ));
  } else {
    alarmResolutionOptions = alarmList.map((alarm :string, index: number) => (
      <option key={ index } value={ alarm }>{ alarm }</option>
    ));
  }

  if(props.exemptions.screened) {
    screening = props.exemptions.screened.map((alt :string, index: number) => (
      <option key={ index } value={ alt }>{ alt }</option>
    ));
  } else {
    screening = screenedOptions.map((alt :string, index: number) => (
      <option key={ index } value={ alt }>{ alt }</option>
    ));
  }

  if(props.exemptions.exemptions_domestic) {
    exemptionsDomesticOptions = props.exemptions.exemptions_domestic.map((alt :string, index: number) => (
      <option key={ index } value={ alt }>{ alt }</option>
    ));
  }

  if(props.exemptions.exemptions_international) {
    exemptionsIntOptions = props.exemptions.exemptions_international.map((alt :string, index: number) => (
      <option key={ index } value={ alt }>{ alt }</option>
    ));
  }

  if(props.exemptions.chain_of_custody) {
    chainOfCustodyOptions = props.exemptions.chain_of_custody.map((alt :string, index: number) => (
      <option key={ index } value={ alt }>{ alt }</option>
    ));
  }


  if(props.exemptions.other) {
    otheroptions = props.exemptions.other.map((alt :string, index: number) => (
      <option key={ index } value={ alt }>{ alt }</option>
    ));
  }

  if(props.exemptions.alternative_screening) {
    alternativeOptions = props.exemptions.alternative_screening.map((alt :string, index: number) => (
      <option key={ index } value={ alt }>{ alt }</option>
    ));
  } else {
    alternativeOptions = alternativeScreeningOptions.map((alt :string, index: number) => (
      <option key={ index } value={ alt }>{ alt }</option>
    ));
  }

  if(props.measures.length > 0) {
    measureAppliedOptions = props.measures.map((alt :string, index: number) => (
      <option key={ index } value={ alt }>{ alt }</option>
    ));
  } else {
    measureAppliedOptions = measureTypes.map((alt :string, index: number) => (
      <option key={ index } value={ alt }>{ alt }</option>
    ));
  }


  return (
    <div className={ `${ commonStyles.wrapper }` }>
    { props.piecesSplit.map((el: Screening, i: number) => {
      const screeningLabel: string = el.measure_applied === 'Exemption' ? 'Select Exemption' : el.measure_applied === 'Alternative Screening' ? 'Select Alternative Screening Applied' : 'Select Screening Method';
      const options: Array<JSX.Element> = el.measure_applied === 'Exemption' ? flightExemptionOptions : el.measure_applied === 'Alternative Screening' ? alternativeOptions : 
      el.measure_applied === 'Exemption Domestic Cargo' ? exemptionsDomesticOptions : el.measure_applied === 'Exemption International Cargo' ? exemptionsIntOptions :
      el.measure_applied === 'No Chain of Custody' ? chainOfCustodyOptions : el.measure_applied === 'Other' ? otheroptions : screening;
      const screenedStyles = !el.userCheckBox && !el.disabled ? screeningStyles.nameField : '';
      return (
        <Card className={`${ screeningStyles.mNegRow } ${ screeningStyles.card }`} key={i}>
          <form>
            <div className={ screeningStyles.selectOuter }>
              <Grid container className={ screeningStyles.gridContainer }>
                <Grid item xl={1} lg={1} md={1} sm={6} xs={12} className={`${ commonStyles.mt6px } ${ screeningStyles.gridItems }`}>
                  <FormControl className={[screeningStyles.piecesText, screeningStyles.labelOuter, screeningStyles.w_100].join(" ") }>
                    <label className={ screeningStyles.labelText }>Pcs</label>
                    <TextField
                      required
                      type="number"
                      disabled={ props.piecesSplit[i].disabled || props.disableScreening }
                      id={ `${i}` }
                      name="pieces"
                      value={ props.piecesSplit[i].pieces }
                      onChange={(e) => props.changePieces(e)}
                        className={ [
                          screeningStyles.textField,
                          screeningStyles.pcsField,
                          screeningStyles.ipField
                      ].join(" ") }
                      InputProps={{
                        classes: { root: screeningStyles.inputtextField }
                      }}
                      variant="outlined"
                      fullWidth
                    />
                    { !el.pieces && (
                      <span className={ screeningStyles.errorText }>
                        Please enter number of pieces
                      </span>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xl={2} lg={2} md={2} sm={6} xs={12} className={ [screeningStyles.gridItems, screeningStyles.measureApplied].join(" ") }>
                  <label className={ screeningStyles.labelText }>Measure Applied</label>
                  <div className={ [screeningStyles.labelOuter , screeningStyles.inputtextField].join(" ") }>
                    <Select
                      className ={ screeningStyles.measureInput }
                      native
                      onChange={ (event: any) => props.handleSelectChange(event, 'measure') }
                      value={ props.piecesSplit[i].measure_applied }
                      id={ `${i}` }
                      input={ <OutlinedInput labelWidth={ 0 } /> }
                      disabled={ props.piecesSplit[i].disabled || props.disableScreening }
                      inputProps={{ style: { padding: TEXT_FIELD_PADDINGS, fontSize: SELECT_FONT_SIZE } }}
                      variant="outlined"
                    >
                      <option disabled value={ '' }>Measure Applied</option>
                      { measureAppliedOptions }
                
                    </Select>
                  </div>
                </Grid>
                <Grid item xl={3} lg={3} md={3} sm={6} xs={12} className={ screeningStyles.gridItems }>
                  <label className={ screeningStyles.labelText }>{screeningLabel}</label>
                  <div className={ [screeningStyles.labelOuter , screeningStyles.inputtextField].join(" ") }>
                    <Select 
                      native
                      className={ screeningStyles.exemptions }
                      onChange={ (event: any) => props.handleSelectChange(event, 'details') }
                      value={ props.piecesSplit[i].screening_details }
                      id={ `${i}` }
                      input={ <OutlinedInput labelWidth={ 0 } /> }
                      disabled={ props.piecesSplit[i].disabled || props.disableScreening }
                      inputProps={{ style: { padding: TEXT_FIELD_PADDINGS, fontSize: SELECT_FONT_SIZE } }}           
                      variant="outlined"
                    >

                    <option value={ '' }> {screeningLabel} </option>
                    { options } 
                    
                    </Select>
                  </div>
                  <span className={ screeningStyles.errorText }>
                    { props.errorMessage }
                  </span>
                </Grid>
                <Grid item xl={1} lg={1} md={1} sm={6} xs={12} className={`${ commonStyles.mt6px } ${ screeningStyles.gridItems }`}>
                  <FormControl className={ [screeningStyles.dtlsText, screeningStyles.labelOuter ,screeningStyles.w_100, screeningStyles.mt2px].join(" ") }>
                    <label className={ screeningStyles.labelText }>Screened Wgt</label>
                    <TextField
                      value={ props.piecesSplit[i].actual_weight }
                      id={ `${i}` }
                      disabled={ props.piecesSplit[i].disabled || props.disableScreening }
                      type="number"
                      name="act_weight"
                      onChange={ (e) => props.changeDetails(e, 'act_weight') }
                      fullWidth
                      variant="outlined"
                      InputProps={{
                        classes: { root: screeningStyles.inputtextField }
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xl={2} lg={2} md={2} sm={6} xs={12} className={ [screeningStyles.gridItems, screeningStyles.flightInputContainer].join(" ") }>
                  <div className={ [screeningStyles.w100, screeningStyles.mt2px].join(" ") }>
                    <div className={ screeningStyles.flight }>
                      <label className={ screeningStyles.labelText }>Screened for Flt</label>
                      <div className={ screeningStyles.flightDetail }>
                        <FormControlLabel
                          control={
                            <Checkbox disabled={ props.piecesSplit[i].disabled || props.disableScreening } id={ `${i}` } onChange={ props.selectFlight }  checked={ props.piecesSplit[i].checked } size="small"/>
                          }
                          label="Bkd"
                        />
                      </div>
                    </div>
                    <TextField
                      className={ [screeningStyles.flightDetailInput,screeningStyles.ipField ].join(" ") }
                      value={ props.piecesSplit[i].flight }
                      id={ `${i}` }
                      disabled={ props.piecesSplit[i].disabled || props.disableScreening }
                      onChange={ (e) => props.changeDetails(e, 'flight') }
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{ 
                        style: { fontSize: SELECT_FONT_SIZE }, 
                        classes: { root: screeningStyles.inputtextField },
                      }}           
                      fullWidth
                      variant="outlined"
                    />
                  </div>
                </Grid>
                <Grid item xl={2} lg={2} md={2} sm={6} xs={12} className={ [screeningStyles.gridItems, screeningStyles.flightInputContainer, screeningStyles.mt22px].join(" ") }>
                  <KeyboardDatePicker
                    disabled={ props.piecesSplit[i].disabled || props.disableScreening }
                    value={ props.piecesSplit[i].flightDate }
                    onChange={ (d: any) => props.selectDate(d, i, 'flight') }
                    className={ [screeningStyles.datePickerFlight,screeningStyles.ipField,screeningStyles.datePicker].join(" ") }
                    fullWidth
                    format={"DD MMM YYYY"}
                    InputProps={{ 
                      classes: { root: screeningStyles.inputtextField },
                    }}
                    inputVariant="outlined"
                  />
                </Grid>
                <Grid item xl={3} lg={3} md={3} sm={6} xs={12}className={ [screeningStyles.gridItems, screeningStyles.labelOuter, screeningStyles.screener].join(" ") } >
                  <div className={ screeningStyles.w100 }>
                    <div className={ screeningStyles.flight }>
                    <label className={ screeningStyles.labelText }>Screener</label>
                      <div className={ screeningStyles.flightDetail }>
                        <FormControlLabel
                          control={
                            <Checkbox disabled={ props.piecesSplit[i].disabled || props.disableScreening } id={ `${i}` } onChange={ () => props.setUserManually(i) } checked={ props.piecesSplit[i].userCheckBox } size="small" />
                          }
                          label="Screened By Someone Else"
                        />
                      </div>
                    </div>
            
                    <TextField
                      disabled={ !props.piecesSplit[i].userCheckBox || props.piecesSplit[i].disabled || props.disableScreening }
                      id={ `${i}` }
                      onChange={ (e) => props.changeDetails(e, 'screener') }
                      value={ props.piecesSplit[i].screened_by }
                      className={ [screeningStyles.textField, screenedStyles, screeningStyles.flexEnd].join(" ") }
                      inputProps={{ 
                        style: { padding: TEXT_FIELD_PADDINGS, fontSize: SELECT_FONT_SIZE },
                        classes: { root: screeningStyles.inputtextField }
                        }}  
                      fullWidth
                      variant="outlined"
                    />
                  </div>
                </Grid>
                <Grid item xl={2} lg={2} md={2} sm={6} xs={12} className={[screeningStyles.gridItems,screeningStyles.sDateTimeContainer].join(" ")} >
                  <div className={ screeningStyles.dateWrapper }>
                    <div className={ commonStyles.inputLabel }>Date</div>
                    <KeyboardDatePicker
                      disabled={ props.piecesSplit[i].disabled || props.disableScreening }
                      value={ props.piecesSplit[i].date_time }
                      onChange={ (d: any) => props.selectDate(d, i, 'screening') }
                      className={ [screeningStyles.datePicker,screeningStyles.w_100,screeningStyles.ipField].join(" ") }
                      format={"DD MMM YYYY"}
                      InputProps={{ 
                        classes: { root: screeningStyles.inputtextField },
                      }}
                      fullWidth
                      inputVariant="outlined"
                    />
                  </div>
                </Grid>
                <Grid item xl={2} lg={2} md={2} sm={6} xs={12} className={ [screeningStyles.gridItems,screeningStyles.sDateTimeContainer].join(" ")} >
                  <div className={ screeningStyles.dateWrapper }>
                    <div className={ commonStyles.inputLabel }>Time</div>
                    <TimePicker
                      clearable
                      format={ "HH:mm" }
                      disabled={ props.piecesSplit[i].disabled || props.disableScreening }
                      value={ moment(props.piecesSplit[i].time, "HH:mm:ss") }
                      onChange={ (d: any) => props.handleDateChange(d, i) }
                      className={ [screeningStyles.timePicker, screeningStyles.w_100, screeningStyles.ipField].join(" ") }
                      InputProps={{
                        classes: { root: screeningStyles.inputtextField },
                        endAdornment: (
                          <InputAdornment position="end" >
                            <QueryBuilder color='primary' />
                          </InputAdornment>
                        )
                      }}
                      fullWidth
                      inputVariant="outlined"
                    />
                  </div>
                </Grid>
                <Grid item xl={2} lg={2} md={2} sm={6} xs={12} className={ `${ screeningStyles.gridItems } ${commonStyles.mt2}` }>
                  <div>
                    <FormControlLabel
                      control={
                        <Checkbox disabled={ props.piecesSplit[i].disabled || props.disableScreening } id={ `${i}` }   onChange={ (event: any) => props.handleSelectChange(event, 'alarm') } checked={ props.piecesSplit[i].alarm } />
                      }
                      label="Screening Alarm"
                    />
                  </div>
                  
                </Grid>
                <Grid item xl={2} lg={2} md={2} sm={6} xs={12} className={ screeningStyles.gridItems }>
                  {props.piecesSplit[i].alarm && <div>
                  <label className={ screeningStyles.labelText }>Alarm Resolution</label>
                    <div className={ [screeningStyles.labelOuter , screeningStyles.inputtextField].join(" ") }>
                      <Select
                        className ={ screeningStyles.measureInput }
                        native
                        onChange={ (event: any) => props.handleSelectChange(event, 'resolution') }
                        value={ props.piecesSplit[i].alarm_resolution }
                        id={ `${i}` }
                        input={ <OutlinedInput labelWidth={ 0 } /> }
                        disabled={ props.piecesSplit[i].disabled || props.disableScreening }
                        inputProps={{ style: { padding: TEXT_FIELD_PADDINGS, fontSize: SELECT_FONT_SIZE } }}
                        variant="outlined"         
                      >
                        <option disabled value={ '' }>Alarm Resolution</option>
                        { alarmResolutionOptions }
                
                      </Select>
                    </div>
                  </div>
                  }
                </Grid>
                <Grid item xl={3} lg={3} md={3} sm={6} xs={12} className={ screeningStyles.gridItems }>

                <label className={ screeningStyles.labelText }>Remarks</label>
                    <TextField
                      value={ props.piecesSplit[i].details }
                      id={ `${i}` }
                      disabled={ props.piecesSplit[i].disabled || props.disableScreening }
                      name="details"
                      onChange={ (e) => props.changeDetails(e, 'remarks') }
                      fullWidth
                      variant="outlined"
                      InputProps={{
                        classes: { root: screeningStyles.inputtextField }
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                </Grid>
                <Grid item xl={8} lg={8} md={8} sm={12} xs={12} className={`${ screeningStyles.gridItems } ${ commonStyles.mb0 }`} >
                    <div className={ screeningStyles.btnContainer }>
                    { !(props.piecesSplit[i].disabled  || props.disableScreening ) && (
                      <div className={ screeningStyles.SaveBtnOuter }>
                        <Button
                          color="primary"
                          onClick={ (e) => props.submitScreening(e, i) }
                          className={ screeningStyles.buttonSave }
                        >
                          <SaveIcon/>
                        </Button>
                      </div>
                    ) } 
                    { props.piecesSplit[i].id && props.piecesSplit[i].disabled  && (
                      <div className={ screeningStyles.actionBtn }>
                        <IconButton
                          aria-label="Filter"
                          className={ screeningStyles.button }
                          onClick={ () => props.editCard(i) }
                        >
                          <EditIcon
                            color="primary"
                            className={ screeningStyles.materialIcon }
                          />
                        </IconButton>
                        {
                          <IconButton
                            disabled={ props.piecesSplit.length < 2 }
                            aria-label="Filter"
                            onClick={ () => props.deleteCard(i) }
                          >
                            <DeleteOutlineIcon
                              color="primary"
                              className={ screeningStyles.materialIcon }
                            />
                          </IconButton>
                        }
                        { props.piecesSplit.length === i + 1 && (
                          <IconButton
                            aria-label="Filter"
                            className={ screeningStyles.button }
                            onClick={props.addCard}
                          >
                            <AddBoxIcon
                              color="primary"
                              className={ screeningStyles.materialIcon }
                            />
                          </IconButton>
                        )}
                      </div>

                    )}
                  </div >
                </Grid>
                { props.disableScreening && (
                  <div className={ screeningStyles.shipmentReturned }>
                    Shipment Returned To Driver
                  </div>
                ) }
              </Grid>
              
            </div>
          </form>
        </Card>
      );
    }) }
  </div>
  )
}

export default withStyles(styles)(screeningCard);